import Accounts from "components/directories/Accounts";
import { useState } from "react";



export default function Income(subEntity: any) {

    const onChangeMenu = (e: any) => {

    }
    let [activeMenu, setActiveMenu] = useState("Production");
    return (<>

        <div className="ws-12">


            <Accounts onChangeMenu={onChangeMenu} activeMenu={activeMenu} />


        </div>
    </>
    )
}